import { Component, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import {
  MatTableDataSource,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
} from '@angular/material/table';
import { SzamlazzhuService } from 'src/app/services/szamlazzhu/szamlazzhu.service';
import { MissingRefIdItem } from 'src/app/services/szamlazzhu/types';
import { SetInvoiceDialogComponent } from './set-invoice-dialog/set-invoice-dialog.component';
import { PayeeButtonComponent } from '../../../../shared/payee-buttons/payee-button/payee-button.component';
import { DecimalPipe, DatePipe } from '@angular/common';

@Component({
  selector: 'app-missing-ref-ids',
  templateUrl: './missing-ref-ids.component.html',
  styleUrls: ['./missing-ref-ids.component.scss'],
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    PayeeButtonComponent,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatPaginator,
    DecimalPipe,
    DatePipe,
  ],
})
export class MissingRefIdsComponent implements OnInit {
  private szamlazzhuService = inject(SzamlazzhuService);
  private dialog = inject(MatDialog);

  page: number = 0;
  perPage: number = 10;
  length = Infinity;

  readonly displayedColumns = [
    'remaining_amount',
    'original_amount',
    'due_date_at',
    'invoice_file_name',
    'set_invoice',
  ];
  readonly dataSource = new MatTableDataSource<MissingRefIdItem>();

  async ngOnInit(): Promise<void> {
    await this.setClaims({
      length: this.length,
      pageIndex: this.page,
      pageSize: this.perPage,
    });
  }

  async setClaims(event: PageEvent): Promise<void> {
    this.page = event.pageIndex;
    this.perPage = event.pageSize;
    try {
      const result = await this.szamlazzhuService.getMissingRefIds({
        page: this.page + 1,
        per_page: this.perPage,
      });
      this.dataSource.data = result.data;
      this.length = result.pagination.total;
    } catch (error: unknown) {
      console.error('Error while getting missing ref ids', error);
    }
  }

  openSetInvoiceDialog(item: MissingRefIdItem): void {
    this.dialog.open(SetInvoiceDialogComponent, {
      data: item,
      autoFocus: false,
    });
  }
}
